import React from 'react';

const Footer = () => {
  return (
    <div style={{ textAlign: 'center', padding: '10px', fontSize: '12px', color: '#999' }}>
      © 2025 Anuvadini AI. All rights reserved.
    </div>
  );
};

export default Footer;